import React from 'react';
import { useAppSelector } from '../../store/reducers/store';
import OverviewTab from './tabs/OverviewTab';
import { Box } from '@mui/material';
import PortfolioAllocationTab from './tabs/PortfolioAllocationTab';
import FundsTab from './tabs/FundsTab';
import InvestmentTicketsTab from './tabs/InvestmentTicketsTab';
import InvestorsTab from './tabs/InvestorsTab';
import ReportsDataRoomTab from './tabs/ReportsDataRoomTab';

const PortfolioDetailsTabContent: React.FC = () => {
    const tab = useAppSelector(state => state.portfolioDetails.tab);
    let content = <></>
    switch (tab){
        case 0:
            content = <OverviewTab />;
            break;
        case 1:
            content = <PortfolioAllocationTab />;
            break;
        case 2:
            content = <FundsTab />;
            break;
        case 3:
            content = <InvestmentTicketsTab />;
            break;
        case 4:
            content = <InvestorsTab />
            break;
        case 5:
            content = <ReportsDataRoomTab />
            break;
    }
    return <Box display="flex" justifyContent={"stretch"} width={"100%"} gap={"18px"} padding={"23px 0"}>{content}</Box>;
}

export default PortfolioDetailsTabContent;